import {Button} from 'bigdatr-style';
import {Flex} from 'bigdatr-style/layout';
import React from 'react';
import rqApi from '~/api';
import {useRoutes} from '~/app/Router';

export default function NzCreativeInsightLaunch() {
    const submitTrackingForm = rqApi.useSubmitHubspotForm();
    const routes = useRoutes();
    return (
        <>
            <p>
                There&apos;s a new feature in your creative library to help you speed up competitor
                analysis in New Zealand!
            </p>

            <p>
                Using the power of AI, Creative Insights extracts demographic profiles and core
                messaging strategies within advertising creatives.{' '}
            </p>

            <p>
                Each creative we collect will undergo systematic analysis to identify the age and
                gender profiles it targets.
            </p>

            <p>
                When viewing competitor creatives, you&apos;ll also find a comprehensive summary of
                the core value propositions and messaging strategy aimed at that target audience.
            </p>

            <p>
                Alongside our recent launch of Creative Index, you can uncover not just what
                competitors run, but when they increase activity, to which target audience and
                demographic.
            </p>

            <p>Creative Insights is now live in Advertising Creative. </p>

            <Flex>
                <Button
                    onClick={() => {
                        submitTrackingForm.mutate(
                            {formId: 'c2c35ac9-55ef-4068-a9e0-973c98731d42'},
                            {
                                onSuccess: () => {
                                    routes.exploreCreative.push({
                                        creativeModalId: 'acnz7610344879',
                                        filter: {
                                            creativeDateRange: {
                                                absolute: {
                                                    startDate: '2025-07-01',
                                                    endDate: '2025-07-30'
                                                }
                                            },
                                            aiIndustryV1: ['Banking and Finance']
                                        },
                                        creativeListOrderBy: {field: 'lastAppeared', order: 'DESC'},
                                        page: 3
                                    });
                                }
                            }
                        );
                    }}
                >
                    View Creative Insights
                </Button>
            </Flex>
        </>
    );
}
